// extracted by mini-css-extract-plugin
export default {"brand":"index_brand_ASV84"};